<div class="m-content" style="margin-right:1%">
  <div class="m-portlet m-portlet--tab" style="padding:1em;">
      <div class="m-portlet__body1 form-group m-form__group row">
          <div class="col-6">
              <h4 class="m-portlet__head-text">
                 Bank Details
              </h4>
          </div>
          <div class="m-demo__preview m-demo__preview--btn col-6" style="text-align: right">
              <button type="button" class="btn m-btn--pill btn-secondary" style="border-color: #ef7e22;color: #ef7e22;" (click)="onBack()">Back</button>
              <button type="button" class="btn m-btn--pill btn-secondary" style="border-color: #ef7e22;color: #ef7e22;" (click)="addBankDetails()">Add Bank Details</button>
          </div>

          <hr>

          <br>
          <div class="col-md-12">
              <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded" id="scrolling_horizontal" style="position: static; zoom: 1;">
                  <table class="table table-striped">
                      <tr>
                          <th>
                              <strong>Account Holder Name</strong>
                          </th>
                          <th>
                              <strong>Account Number</strong>
                          </th>
                          <th>
                                <strong>Account Type</strong>
                            </th>
                          <th>
                              <strong>Ifsc Code</strong>
                          </th>
                          <th>
                              <strong>Bank Name</strong>
                          </th>
                          <th>
                              <strong>Bank Address</strong>
                          </th>
                        
                          <th>
                            <strong>Added On</strong>
                        </th>
                        <th>
                            <strong>Updated On</strong>
                        </th>
                        <th>
                            <strong>Status</strong>
                        </th>
                        <th>
                            <strong>Action</strong>
                        </th>
                      </tr>
                      <tr *ngFor="let bankData of bankDetailsData">

                          <td>{{bankData.accountHolderName}}</td>
                          <td>{{bankData.accountNumber}}</td>
                          <td>{{bankData.accountType}}</td>
                          <td>{{bankData.ifscCode}}</td>
                          <td>{{bankData.bankName}}</td>
                          <td>{{bankData.bankAddress}}</td>
                          <td>{{bankData.createdOn | date }}</td>
                          <td>{{bankData.updatedOn | date }}</td>
                          <td>
                                <span  [style.background-color]="statusColor[bankData.status]"  class="m-badge m-badge--brand m-badge--wide status-btn" >{{bankData.status}}</span>
                              </td>
                          <td>
                              <div class="dropdown dropup">
                                  <a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="false">
                                      <i class="la la-ellipsis-h"></i>
                                  </a>
                                  <div class="dropdown-menu dropdown-menu-right" x-placement="top-end" style="position: absolute; transform: translate3d(-132px, -143px, 0px); top: 0px; left: 0px; will-change: transform;">
                                      <!-- <a class="dropdown-item">View Details</a> -->
                                      <a class="dropdown-item" (click)="updateBankDetails(bankData)">Update Bank Details</a>
                                  </div>
                              </div>
                          </td>
                      </tr>
                      <tr *ngIf="bankDetailsData.length === 0" style="color:grey;font-size:17px">
                        <td colspan="10">
                            <p style="text-align:center;">No Bank Details Found</p>
                        </td>
                    </tr>
                      <!-- <tr *ngIf="batchArray.length === 0" style="color:grey;font-size:17px">
                          <td colspan="8">
                              <p style="text-align:center;">No Batch Found For Respective Placement Officer</p>
                          </td>
                      </tr> -->
                  </table>
              </div>
              <!-- <div *ngIf="length>9">
                  <app-pagination [count]=length (pageNumber)="assignPageNo($event)" (recordsPerPage)="assignRecordsPerPage($event)"></app-pagination>
              </div> -->
          </div>
      </div>
  </div>
</div>

<div class="modal fade show" id="bank-details-modal" tabindex="-1" role="dialog" style="padding-right: 17px;">
  <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Bank Details</h5>
              <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
          </div>
          <div class="modal-body">
            <div class="m-form__heading ">
                <h3 class="m-form__heading-title ">
                    Bank Details:
                </h3>
            </div>
            <div [formGroup]="tpSchemeBankDetails">
            <div class="form-group m-form__group row ">
                <label class="col-lg-4 col-form-label ">
                   Account Holder Name:
                    <span class="astrickColor">*</span>
                </label>
                <div class="col-lg-4 ">
                    <input type="text " class="form-control m-input notranslate " placeholder="Enter Account Holder Name " formControlName="accountHolderName">
                    <app-form-control-messages [control]="tpSchemeBankDetails.get( 'accountHolderName') " [name]=" 'Account Holder Name' "></app-form-control-messages>
                </div>
            </div>
            <div class="form-group m-form__group row ">
                <label class="col-lg-4 col-form-label ">
                   Account Number:
                    <span class="astrickColor">*</span>
                </label>
                <div class="col-lg-4 ">
                    <input type="text" class="form-control m-input notranslate" placeholder="Enter Account Number "  formControlName="accountNumber">
                    <app-form-control-messages [control]="tpSchemeBankDetails.get( 'accountNumber') " [name]=" 'Account Number' "></app-form-control-messages>
                </div>
            </div>
            <div class="form-group m-form__group row ">
                <label class="col-lg-4 col-form-label ">
                   Confirm Account Number:
                    <span class="astrickColor">*</span>
                </label>
                <div class="col-lg-4 ">
                    <input  type="password" class="form-control m-input notranslate" placeholder="Enter Account Number "  formControlName="confirmAccountNumber">
                    <app-form-control-messages [control]="tpSchemeBankDetails.get( 'confirmAccountNumber') " [name]=" 'Confirm Account Number' "></app-form-control-messages>
                </div>
            </div>
            <div class="form-group m-form__group row ">
                <label class="col-lg-4 col-form-label ">
                   Account Type:
                    <span class="astrickColor">*</span>
                </label>
                <div class="col-lg-4 ">
                        <select class="form-control m-input notranslate" formControlName="accountType">
                                <option value="" disabled selected>Select Account Type</option>
                                <option value="Savings Deposit A/c" >Savings Deposit A/c</option>
                                <option value="Current Deposit A/c" >Current Deposit A/c</option>
                                <option value="Fixed Deposit A/c:" >Fixed Deposit A/c</option>
                                <option value="Recurring Deposit A/c" >Recurring Deposit A/c</option>
                        </select>
                    <app-form-control-messages [control]="tpSchemeBankDetails.get( 'accountType') " [name]=" 'Account Type' "></app-form-control-messages>
                </div>
            </div>
            <div class="form-group m-form__group row ">
                <label class="col-lg-4 col-form-label ">
                   IFSC Code:
                    <span class="astrickColor">*</span>
                </label>
                <div class="col-lg-4 ">
                    <input type="text "  (focusout)="getBankAddressByIfscCode()"  class="form-control m-input notranslate" placeholder="Enter IFSC Code " maxlength="50 " formControlName="ifscCode">
                    <app-form-control-messages [control]="tpSchemeBankDetails.get( 'ifscCode') " [name]=" 'IFSC Code' "></app-form-control-messages>
                </div>
            </div>
            <div class="form-group m-form__group row ">
                <label class="col-lg-4 col-form-label ">
                   Bank Name:
                    <span class="astrickColor">*</span>
                </label>
                <div class="col-lg-4 ">
                    <input type="text " class="form-control m-input notranslate " placeholder="Enter Bank Name " formControlName="bankName">
                    <app-form-control-messages [control]="tpSchemeBankDetails.get( 'bankName') " [name]=" 'Bank Name' "></app-form-control-messages>
                </div>
            </div>
            <div class="form-group m-form__group row ">
                <label class="col-lg-4 col-form-label ">
                   Bank Address:
                    <span class="astrickColor">*</span>
                </label>
                <div class="col-lg-4 ">
                    <textarea   type="text " class="form-control m-input notranslate" placeholder="Enter Bank Address " formControlName="bankAddress"></textarea>
                    <app-form-control-messages [control]="tpSchemeBankDetails.get( 'bankAddress') " [name]=" 'Bank Address' "></app-form-control-messages>
                </div>
            </div>

        </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary"  (click)="closeModal()">Close</button>
              <button type="button" class="btn btn-primary" [disabled]="tpSchemeBankDetails.status === 'INVALID'" (click)="submitBankDetails()">Save</button>
          </div>
      </div>
  </div>
</div>

<div class="modal fade" id="otp-model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content alignModel">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                    OTP Verification
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeOTPModel()">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
            </div>
            <div class="modal-body">
                <form class="m-form m-form--fit m-form--label-align-right" [formGroup]="verifyOTPForm">
                    <div class="form-group m-form__group row" >
                        <label for="tp-details" class="col-3 col-form-label">
							Enter Mobile OTP:
							<span class="mandatoryColor">*</span>
						</label>
                        <div class="col-9">
                            <input class="form-control m-input notranslate" type="text" formControlName="mobileOTP" maxlength="6" placeholder="Enter mobile OTP">
                            <app-form-control-messages [control]="verifyOTPForm.controls.mobileOTP" [name]="'Mobile OTP'"></app-form-control-messages>
                        </div>
                    </div>

                    <div class="form-group m-form__group row" >
                        <label for="tp-details" class="col-3 col-form-label">
							Enter Email OTP:
							<span class="mandatoryColor">*</span>
						</label>
                        <div class="col-9">
                            <input class="form-control m-input notranslate" type="text" formControlName="emailOTP" maxlength="6" placeholder="Enter email OTP">
                            <app-form-control-messages [control]="verifyOTPForm.controls.emailOTP" [name]="'Email OTP'"></app-form-control-messages>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-next verifybutton" [disabled]="!verifyOTPForm.valid" (click)="verifyOTP()">
					Verify
				</button> &nbsp; &nbsp;
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeOTPModel()">
					Cancel
				</button>

            </div>
        </div>
    </div>
</div>
